<template>
  <div class="calendar-wrapper">
    <div class="calendar">
      <div class="calendar-header">
        <h2 class="desktop">
          Календар >
          <template v-if="$route.params.tab === '1'"> График </template>
          <template v-else-if="$route.params.tab === '2'">
            Работници за
            <template v-if="activePeriodTab === 0">деня</template>
            <template v-if="activePeriodTab === 1">седмицата</template>
          </template>
          <template v-else-if="$route.params.tab === '3'"
            >Личен график</template
          >
          <template v-else-if="$route.params.tab === '4'">Отпуски</template>
        </h2>
        <div class="selected-date desktop">
          <p v-if="activePeriodTab === 0">
            <strong>{{ date | formatDay }}</strong>
            <span>, {{ date | formatDayOfWeek }}</span>
          </p>
          <p v-if="activePeriodTab === 1">
            <strong>{{ firstDay | formatDay }}</strong>
            -
            <strong>{{ lastDay | formatDay }}</strong>
          </p>
        </div>
        <div class="mobile-datepicker">
          <div
            class="mobile-datepicker-toggle"
            @click="showMobileDatepicker = !showMobileDatepicker"
          >
            <span v-if="activePeriodTab === 0">{{ date | formatDay }}</span>
            <span v-if="activePeriodTab === 1"
              >{{ firstDay | formatDay }} - {{ lastDay | formatDay }}</span
            >
            <span class="miv" :class="{ 'rotate-arrow': showMobileDatepicker }"
              >K</span
            >
          </div>
          <div
            class="mobile-datepicker-wrapper"
            :class="{
              'left-panel-week-mode': activePeriodTab === 1,
              'left-panel-day-mode': activePeriodTab === 0,
            }"
            v-show="showMobileDatepicker"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :minimumView="'day'"
              :highlighted="$route.params.tab === '4' ? {} : highlighted"
              :maximumView="'day'"
              :full-month-name="true"
              v-model="date"
              @changedMonth="changeMonth"
            ></datepicker>
          </div>
        </div>
        <div class="calendar-header-left">
          <label class="desktop" for="views1">Изглед по:</label>
          <div class="views" id="views1">
            <button
              class="view left"
              :class="{ 'view-active': activePeriodTab === 0 }"
              @click="changePeriodTab(0)"
            >
              <span class="desktop">Ден</span>
              <span class="miv2 mobile-inline">T</span>
            </button>
            <button
              class="view right"
              :class="{ 'view-active': activePeriodTab === 1 }"
              @click="changePeriodTab(1)"
            >
              <span class="desktop">Седмица</span>
              <span class="miv2 mobile-inline">S</span>
            </button>
            <!-- <button class="view right" :class="{ 'view-active' : activePeriodTab === 2 }">Месец</button> -->
          </div>
        </div>
      </div>
      <div class="calendar-content">
        <div
          class="left-panel"
          :class="{
            'left-panel-week-mode': activePeriodTab === 1,
            'left-panel-day-mode': activePeriodTab === 0,
          }"
        >
          <div class="left-panel-header">
            <div class="views" id="views2">
              <template v-if="getUser.permissions.isAdmin">
                <button
                  class="view left"
                  :class="{ 'view-active': $route.params.tab === '1' }"
                  @click="changeContentTab(1)"
                >
                  Обекти
                </button>
                <button
                  class="view right"
                  :class="{ 'view-active': $route.params.tab === '2' }"
                  @click="changeContentTab(2)"
                >
                  Работници
                </button>
              </template>
              <button
                class="view right"
                :class="{ 'view-active': $route.params.tab === '3' }"
                @click="changeContentTab(3)"
              >
                Личен
              </button>
              <button
                class="view right"
                :class="{ 'view-active': $route.params.tab === '4' }"
                @click="changeContentTab(4)"
              >
                Отпуски
              </button>
            </div>
          </div>
          <datepicker
            class="desktop"
            :language="bg"
            :inline="true"
            :monday-first="true"
            :minimumView="'day'"
            :highlighted="$route.params.tab === '4' ? {} : highlighted"
            :maximumView="'day'"
            :full-month-name="true"
            v-model="date"
            @changedMonth="changeMonth"
          ></datepicker>
          <template v-if="$route.params.tab === '1' && activePeriodTab === 0">
            <button class="btn-plan" @click="isAddCompaniesModalOpened = true">
              ПЛАНИРАЙ СЛУЖИТЕЛИ ПО ОБЕКТИ
            </button>
            <img class="legend desktop" src="../assets/img/legend.svg" alt="" />
          </template>
          <!-- WORKERS -->
          <div
            class="new-content-data-item-toggle desktop"
            v-if="$route.params.tab === '2' && activePeriodTab === 0"
          >
            <p>
              <strong>{{ date | formatDayYear }}</strong>
              - Работници по обекти ({{ calendars.length }})
            </p>
          </div>
          <div
            class="new-content-data-item desktop"
            v-if="$route.params.tab === '2' && activePeriodTab === 0"
          >
            <div
              class="new-content-data-item-content"
              :class="{
                'new-content-data-item-content-no-results': !calendars.length,
              }"
            >
              <template v-if="calendars.length">
                <div class="new-content-data-list">
                  <p
                    v-for="(c, index) in calendars"
                    :key="`object-${index}-addedWorker-${c._id}`"
                  >
                    {{ c.worker ? c.worker.name : "" }}
                  </p>
                </div>
              </template>
              <p v-else>Няма добавени работници за деня</p>
            </div>
          </div>
          <template v-if="$route.params.tab === '4'">
            <div
              class="new-content-data-item-toggle desktop"
              @click="isAddOtpuskModalOpened = true"
            >
              <p>
                <strong>{{ date | formatDayYear }}</strong>
                - Отпуски за
                {{ activePeriodTab === 0 ? "деня" : "седмицата" }} ({{
                  otpusks.length
                }})
              </p>
              <span class="new-content-data-item-toggle-circle">
                <span class="miv">V</span>
              </span>
            </div>
            <div class="new-content-data-item desktop">
              <div
                class="new-content-data-item-content"
                :class="{
                  'new-content-data-item-content-no-results': !otpusks.length,
                }"
              >
                <template v-if="otpusks.length">
                  <p
                    v-for="(o, index) in otpusks"
                    :key="`object-${index}-addedWorker-${o.worker._id}`"
                  >
                    {{ o.worker.name }}
                  </p>
                </template>
                <p v-else>
                  Няма добавени отпуски за
                  {{ activePeriodTab === 0 ? "деня" : "седмицата" }}
                </p>
              </div>
            </div>
          </template>
        </div>
        <div class="right-panel" id="rightPanel">
          <!-- OBJECTS CALENDAR -->
          <div
            class="objects-calendar"
            v-if="$route.params.tab === '1' && calendars.length"
          >
            <template v-if="activePeriodTab === 0 && calendars.length">
              <div
                class="objects-calendar-item"
                v-for="(c, index) in calendars"
                :key="`objects-calendar-item-${index}`"
              >
                <div class="objects-calendar-item-header">
                  <p>{{ c.company.companyName }}</p>
                  <p>{{ c.project.projectName }}</p>
                  <p>{{ c.object.objectName }}</p>
                </div>
                <div class="objects-calendar-item-content">
                  <div
                    class="objects-calendar-item-content-add"
                    :class="{
                      'objects-calendar-item-content-add-hidden':
                        c.workers.length ||
                        (c.reportedNonplanned
                          ? c.reportedNonplanned.length
                          : false),
                    }"
                  >
                    <div class="add-items-wrapper">
                      <div
                        class="objects-calendar-item-content-add-item"
                        @click="selectedObject = index"
                      >
                        <span class="miv">V</span>
                        <p>Добавяне на работници</p>
                      </div>
                      <div
                        class="objects-calendar-item-content-add-item add-item-copy"
                        @click="openCopyMoveCalendarModal('copy', c._id)"
                      >
                        <span class="miv2">M</span>
                        <p>Копиране</p>
                      </div>
                      <div
                        class="objects-calendar-item-content-add-item add-item-move"
                        @click="openCopyMoveCalendarModal('move', c._id)"
                      >
                        <span class="miv2">N</span>
                        <p>Преместване</p>
                      </div>
                    </div>
                    <div
                      class="objects-calendar-item-content-add-item add-item-delete"
                      @click="removeCalendar(c)"
                    >
                      <span class="miv">b</span>
                      <p>Изтриване</p>
                    </div>
                  </div>
                  <div class="workers-container">
                    <div class="workers-container__loading" v-if="c.loading">
                      <img
                        class="loading"
                        src="../assets/img/loading_dark.svg"
                        alt="loading"
                      />
                    </div>
                    <template v-else>
                      <div
                        v-for="w in c.workers"
                        :key="`${c.object._id}-${w._id}`"
                        class="workers-tag workers-tag--not-reported"
                        :class="{
                          'workers-tag--reported': c.reported
                            ? c.reported.indexOf(w._id) > -1
                            : false,
                          'workers-tag--reported-elsewhere': c.reportedElsewhere
                            ? c.reportedElsewhere.indexOf(w._id) > -1
                            : false,
                        }"
                      >
                        {{ w.name }}
                      </div>
                      <div
                        v-for="w in c.reportedNonplanned"
                        :key="`${c.object._id}-${w._id}`"
                        class="workers-tag workers-tag--reported-nonplanned"
                      >
                        {{ w.name }}
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="activePeriodTab === 1">
              <div
                class="big-calendar-item"
                v-for="c in calendars"
                :key="c._id"
              >
                <div class="date-calendar-item-header">
                  <p>{{ c.date | formatDay }}</p>
                  <p class="date-calendar-objects-count">
                    <span class="miv2">P</span>
                    {{ c.calendars ? c.calendars.length : 0 }}&nbsp;
                    <span v-if="c.calendars ? c.calendars.length === 1 : false"
                      >Обект</span
                    >
                    <span v-else>Обекта</span>
                  </p>
                </div>
                <div class="big-calendar-item-content">
                  <div class="companies-container">
                    <div
                      v-for="ca in c.calendars"
                      :key="ca._id"
                      class="companies-tag"
                    >
                      <template v-if="ca">
                        <p>{{ ca.company.companyName }}</p>
                        <p>{{ ca.project.projectName }}</p>
                        <p>{{ ca.object.objectName }}</p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- WORKERS CALENDAR -->
          <div
            class="workers-calendar"
            v-if="$route.params.tab === '2' && calendars.length"
          >
            <template v-if="activePeriodTab === 0">
              <div
                class="workers-calendar-item"
                v-for="c in calendars"
                :key="c._id"
              >
                <div class="workers-calendar-item-header">
                  <p>{{ c.worker ? c.worker.name : "" }}</p>
                </div>
                <div class="workers-calendar-item-content">
                  <div class="companies-container">
                    <div
                      v-for="co in c.companies"
                      :key="co._id"
                      class="companies-tag"
                    >
                      <template v-if="co">
                        <p>{{ co.company.companyName }}</p>
                        <p>{{ co.project.projectName }}</p>
                        <p>{{ co.object.objectName }}</p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="activePeriodTab === 1">
              <div
                class="big-calendar-item"
                v-for="c in calendars"
                :key="c._id"
              >
                <div class="date-calendar-item-header">
                  <p>{{ c.date | formatDay }}</p>
                  <p class="date-calendar-objects-count">
                    <span class="miv2">Q</span>
                    {{ c.workers.length }}&nbsp;
                    <span v-if="c.workers.length === 1">Работник</span>
                    <span v-else>Работника</span>
                  </p>
                </div>
                <div class="objects-calendar-item-content">
                  <div class="workers-container">
                    <div
                      v-for="w in c.workers"
                      :key="`${c._id}-${w._id}`"
                      class="workers-tag"
                    >
                      {{ w.name }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- PERSONAL CALENDAR -->
          <div
            class="big-calendar"
            :class="{ 'personal-calendar': activePeriodTab === 0 }"
            v-if="$route.params.tab === '3' && calendars.length"
          >
            <div class="big-calendar-item" v-for="c in calendars" :key="c._id">
              <div class="date-calendar-item-header">
                <p>{{ c.date | formatDay }}</p>
                <p class="date-calendar-objects-count">
                  <span class="miv2">P</span>
                  {{ c.calendars.length }}&nbsp;
                  <span v-if="c.calendars.length === 1">Обект</span>
                  <span v-else>Обекта</span>
                </p>
              </div>
              <div class="big-calendar-item-content">
                <div
                  v-for="ca in c.calendars"
                  :key="ca._id"
                  class="personal-tag"
                >
                  <template v-if="ca">
                    <div class="left">
                      <p>{{ ca.company.companyName }}</p>
                      <p>{{ ca.project.projectName }}</p>
                      <p>{{ ca.object.objectName }}</p>
                    </div>
                    <div class="right">
                      <template v-if="activePeriodTab === 0">
                        <p
                          v-for="(w, index) in ca.workers"
                          :key="`${ca._id}-${index}-${w._id}`"
                        >
                          {{ w.name }}
                        </p>
                      </template>
                      <div
                        v-if="activePeriodTab === 1"
                        class="big-calendar-count-toggle"
                      >
                        <span class="miv2">Q</span>
                        <span>{{ ca.workers.length }}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- OTPUSKS -->
          <!-- OBJECTS CALENDAR -->
          <div
            class="objects-calendar"
            v-if="$route.params.tab === '4' && otpusks.length"
          >
            <div
              class="objects-calendar-item"
              v-for="(o, index) in otpusks"
              :key="`otpusk-${index}-${o.worker._id}`"
            >
              <div
                class="objects-calendar-item-content"
                :class="{
                  'objects-calendar-item-content-highlight':
                    $route.query.id === o._id,
                }"
              >
                <div
                  class="objects-calendar-item-content-add objects-calendar-item-content-add-hidden otpusks-hover-container"
                  v-if="
                    canApprove ||
                    getUser.permissions.isSuperAdmin ||
                    getUser.permissions.isHR
                  "
                >
                  <div class="otpusks-container-top">
                    <p v-if="canApprove && !o.confirmedAt">Решение за отпуска</p>
                  </div>
                  <div class="otpusks-container-bottom">
                    <div
                      class="add-items-wrapper"
                      v-if="canApprove && !o.confirmedAt"
                    >
                      <div
                        class="objects-calendar-item-content-add-item add-item-confirm"
                        @click="confirmOtpusk(o, true)"
                      >
                        <span class="miv2">f</span>
                        <p>Да</p>
                      </div>
                      <div
                        class="objects-calendar-item-content-add-item add-item-reject"
                        @click="confirmOtpusk(o, false)"
                      >
                        <span class="miv">F</span>
                        <p>Не</p>
                      </div>
                    </div>
                    <div
                      class="objects-calendar-item-content-add-item"
                      @click="getOutlookUrl(o)"
                      v-else-if="o.confirmed"
                    >
                      <span class="miv">D</span>
                      <p>Добави в Outlook</p>
                    </div>
                    <div
                      class="objects-calendar-item-content-add-item add-item-delete"
                      @click="removeOtpusk(o)"
                    >
                      <span class="miv">b</span>
                      <p>Изтриване</p>
                    </div>
                  </div>
                </div>
                <div
                  class="otpusk-container"
                  :class="`otpusk-container-${o.confirmed}`"
                >
                  <div class="otpusk-container-top">
                    <p class="name">
                      <strong>{{ o.worker.name }}</strong>
                    </p>
                    <div class="otpusk-period-div">
                      <p>
                        <strong>{{ otpuskTypes[o.type] }}</strong>
                      </p>
                      <p v-if="o.comment">
                        <em>{{ o.comment }}</em>
                      </p>
                      <br />
                      <p>от {{ o.dateFrom | formatDate }}</p>
                      <p>до {{ o.dateTo | formatDate }}</p>
                    </div>
                    <div class="otpusk-period-div">
                      <p>
                        <strong>Добавен от:</strong>
                      </p>
                      <p v-if="o.createdBy">{{ o.createdBy.name }}</p>
                      <p v-else>-</p>
                      <p>на {{ o.createdAt | formatDate }}</p>
                    </div>
                  </div>
                  <div class="otpusk-container-bottom">
                    <div class="otpusk-status-wrapper">
                      <div class="otpusk-period-div">
                        <p>
                          <strong>Решение:</strong>
                        </p>
                      </div>
                      <button
                        class="otpusk-status otpusk-status-confirmed"
                        v-if="o.confirmed === true"
                        disabled
                      >
                        <span>ОДОБРЕН</span>
                        <span class="miv2">f</span>
                      </button>
                      <button
                        class="otpusk-status otpusk-status-rejected"
                        v-else-if="o.confirmed === false"
                        disabled
                      >
                        <span>НЕОДОБРЕН</span>
                        <span class="miv">F</span>
                      </button>
                      <button v-else class="otpusk-status" disabled>
                        <span>ДА/НЕ</span>
                        <span class="miv2">l</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="activePeriodTab === 1">
              <div
                class="big-calendar-item"
                v-for="c in calendars"
                :key="c._id"
              >
                <div class="date-calendar-item-header">
                  <p>{{ c.date | formatDay }}</p>
                  <p class="date-calendar-objects-count">
                    <span class="miv2">P</span>
                    {{ c.calendars.length }}&nbsp;
                    <span v-if="c.calendars.length === 1">Обект</span>
                    <span v-else>Обекта</span>
                  </p>
                </div>
                <div class="big-calendar-item-content">
                  <div class="companies-container">
                    <div
                      v-for="ca in c.calendars"
                      :key="ca._id"
                      class="companies-tag"
                    >
                      <template v-if="ca">
                        <p>{{ ca.company.companyName }}</p>
                        <p>{{ ca.project.projectName }}</p>
                        <p>{{ ca.object.objectName }}</p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div
            class="workers-calendar no-results-calendar"
            v-if="!calendars.length && !otpusks.length"
          >
            <div class="workers-calendar-item">
              <div class="workers-calendar-item-header">
                <p v-if="$route.params.tab === '1'">Обекти за деня</p>
                <p v-if="$route.params.tab === '2'">Работници по обекти</p>
                <p v-if="$route.params.tab === '3'">Личен график</p>
                <p v-if="$route.params.tab === '4'">Отпуски</p>
              </div>
              <div class="workers-calendar-item-content">
                <p
                  class="no-results-calendar-p"
                  v-if="$route.params.tab === '3'"
                >
                  За избрания ден не сте разпределен в никой от обектите
                </p>
                <p
                  class="no-results-calendar-p"
                  v-if="$route.params.tab === '4'"
                >
                  Няма планирани отпуски
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <AddUsersModal
        v-if="selectedObject !== undefined"
        :incomingUsers="calendars[selectedObject].workers"
        :usersType="'workers'"
        :date="date"
      />
    </transition>
    <transition name="fade">
      <AddCompaniesModal v-if="isAddCompaniesModalOpened" />
    </transition>
    <transition name="fade">
      <CopyMoveCalendarModal
        v-if="CopyMoveCalendarModalAction"
        :action="CopyMoveCalendarModalAction"
        :id="CopyMoveCalendarModalCalendar"
      />
    </transition>
    <transition name="fade">
      <AddOtpuskModal v-if="isAddOtpuskModalOpened" :date="date" />
    </transition>
  </div>
</template>

<script>
import AddUsersModal from "./shared/AddUsersModal";
import AddCompaniesModal from "./shared/AddCompaniesModal";
import CopyMoveCalendarModal from "./shared/CopyMoveCalendarModal";
import AddOtpuskModal from "./shared/AddOtpuskModal";
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import { mapGetters } from "vuex";
import log from "./mixins/log.js";
export default {
  components: {
    Datepicker: Datepicker,
    AddUsersModal: AddUsersModal,
    AddCompaniesModal: AddCompaniesModal,
    CopyMoveCalendarModal: CopyMoveCalendarModal,
    AddOtpuskModal: AddOtpuskModal,
  },
  mixins: [log],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
  },
  data() {
    return {
      bg: bg,
      months: [
        "Януари",
        "Февруари",
        "Март",
        "Април",
        "Май",
        "Юни",
        "Юли",
        "Август",
        "Септември",
        "Октомври",
        "Ноември",
        "Декември",
      ],
      highlightedDates: [],
      highlighted: { to: "", from: "" },
      date: "",
      firstDay: undefined,
      lastDay: undefined,
      format: "MMMM yyyy",
      activePeriodTab: 0,
      calendars: [],
      otpusks: [],
      workers: [],
      isAddUsersModalOpened: false,
      isAddCompaniesModalOpened: false,
      isAddOtpuskModalOpened: false,
      canApprove: false,
      selectedObject: undefined,
      CopyMoveCalendarModalAction: "",
      CopyMoveCalendarModalCalendar: undefined,
      showMobileDatepicker: false,
      otpuskTypes: {
        paid: "Платен отпуск",
        unpaid: "Неплатен отпуск",
        hospital: "Болничен",
        fake: "Фиктивен",
        notpresent: "Неприсъствен",
        tripovernight: "Командировка с преспиване",
        tripday: "Командировка без преспиване",
      },
    };
  },
  watch: {
    date() {
      this.showMobileDatepicker = false;
      this.firstDay = new Date(this.date).GetFirstDayOfWeek();
      this.lastDay = new Date(this.date).GetLastDayOfWeek();
      if (this.$route.params.tab === "4") {
        this.changeContentTab(4);
      } else {
        this.fetchData();
      }
    },
  },
  methods: {
    changePeriodTab(n) {
      this.calendars = [];
      this.otpusks = [];
      this.showMobileDatepicker = false;
      this.firstDay = new Date(this.date).GetFirstDayOfWeek();
      this.lastDay = new Date(this.date).GetLastDayOfWeek();

      this.activePeriodTab = n;
      this.fetchData();
    },
    changeContentTab(n) {
      this.calendars = [];
      this.otpusks = [];
      this.$router
        .push(
          `/calendar/${n}${
            n === 4
              ? `?date=${this.date.toISOString()}${
                  this.$route.query.id ? `&id=${this.$route.query.id}` : ""
                }`
              : ""
          }`
        )
        .then(() => {
          this.fetchData();
        });
    },
    handleCompanies(c) {
      const url = `${
        process.env.VUE_APP_BASE_URI
      }/calendar/exists/${this.date.toISOString()}/${c.companyId}/${
        c.projectId
      }/${c.objectId}`;
      this.$http.get(url).then((response) => {
        if (!response.data.length) {
          const calendar = {
            date: this.date,
            createdAt: new Date(),
            companyId: c.companyId,
            projectId: c.projectId,
            objectId: c.objectId,
          };
          const url = `${process.env.VUE_APP_BASE_URI}/calendar`;
          this.$http
            .post(url, calendar)
            .then((a) => {
              if (a.data.errors) {
                console.log(a.data.errors);
                this.$snotify.error(`Нещо се обърка`);
              } else {
                const dateString = `${this.date.getDate()} ${
                  this.months[this.date.getMonth()]
                } ${this.date.getFullYear()}`;
                this.$snotify.success(`Успешно добавен обект за ${dateString}`);
                this.fetchData();
                this.closeAddCompaniesModal();
                if (calendar.objectId) {
                  let url = `${process.env.VUE_APP_BASE_URI}/company/object-name/${calendar.objectId}`;
                  return this.$http
                    .get(url)
                    .then((response) => {
                      if (response.data) {
                        this.newLog(
                          "newCalendar",
                          `обект ${response.data[0].objectName} - дата ${dateString}`
                        );
                      }
                    })
                    .catch((error) => console.log(error));
                }
              }
            })
            .catch((error) => {
              console.log(error.response);
              this.$snotify.error(`Нещо се обърка`);
            });
        } else {
          this.$snotify.error(
            `Този обект е вече добавен за ${this.date.getDate()} ${
              this.months[this.date.getMonth()]
            } ${this.date.getFullYear()}`
          );
        }
      });
    },
    // If we get the 'saveWorkersModal' event, we assign the workers we receive to the report
    handleWorkers(workers) {
      const workersArray = [];

      workers.forEach((w) => {
        workersArray.push({
          _id: w._id,
        });
      });

      const newCalendar = this.calendars[this.selectedObject];
      newCalendar.workers = workersArray;

      const url = `${process.env.VUE_APP_BASE_URI}/calendar/${newCalendar._id}`;

      this.$http
        .put(url, newCalendar)
        .then((a) => {
          if (a.data.errors) {
            console.log(a.data.errors);
            this.$snotify.error(`Нещо се обърка`);
          } else {
            this.$snotify.success(`Успешно обновяване на работници.`);
            this.fetchData();
            this.closeAddWorkersModal();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.$snotify.error(`Нещо се обърка`);
        });
    },
    fetchData() {
      this.otpusks = [];
      this.calendars = [];
      if (this.$route.params.tab === "4") {
        this.getOtpusks();
      } else {
        this.getCalendars();
      }
      this.getHighlighted();
    },
    getCalendars() {
      this.$store.dispatch("startLoading");

      let type = "";

      // DAILY
      let firstDate = this.date;
      let secondDate = this.date;
      // WHOLE WEEK
      if (this.activePeriodTab === 1) {
        firstDate = new Date(this.date).GetFirstDayOfWeek();
        secondDate = new Date(this.date).GetLastDayOfWeek();
      }

      if (this.$route.params.tab === "1") {
        type = "day";
      } else if (
        this.$route.params.tab === "2" ||
        this.$route.params.tab === "3"
      ) {
        type = "workers";
      }

      let requestUrl = `${
        process.env.VUE_APP_BASE_URI
      }/calendar/${type}/${this.date.toISOString()}`;

      // BUILD THE REQUEST URL FOR ALL CALENDARS
      if (this.$route.params.tab === "1") {
        // URL
        // DAY
        if (this.activePeriodTab === 0) {
          requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/${type}/${firstDate.toISOString()}`;
        }
        // WEEK
        else if (this.activePeriodTab === 1) {
          requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/${type}/${firstDate.toISOString()}/${secondDate.toISOString()}`;
        }
      }

      // BUILD THE REQUEST URL FOR ALL WORKERS
      if (this.$route.params.tab === "2") {
        // URL
        // DAY
        if (this.activePeriodTab === 0) {
          requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/${type}/${firstDate.toISOString()}`;
        }
        // WEEK
        else if (this.activePeriodTab === 1) {
          requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/${type}/${firstDate.toISOString()}/${secondDate.toISOString()}`;
        }
      }

      // BUILD THE REQUEST URL FOR PERSONAL CALENDAR
      if (this.$route.params.tab === "3") {
        // URL
        requestUrl = `${
          process.env.VUE_APP_BASE_URI
        }/calendar/${type}/${firstDate.toISOString()}/${secondDate.toISOString()}/${
          this.getUser._id
        }`;
      }

      this.$http
        .get(requestUrl)
        .then((response) => {
          this.$store.dispatch("stopLoading");

          this.calendars = response.data;

          if (this.activePeriodTab === 0 && this.$route.params.tab === "1") {
            for (let c of this.calendars) {
              this.$set(c, "loading", true);
              this.$http
                .get(
                  `${process.env.VUE_APP_BASE_URI}/calendar/${c._id}?reported=true`
                )
                .then((res) => {
                  this.$set(c, "reported", res.data.reported);
                  this.$set(c, "reportedElsewhere", res.data.reportedElsewhere);
                  this.$set(
                    c,
                    "reportedNonplanned",
                    res.data.reportedNonplanned
                  );
                })
                .then(() => (c.loading = false));
            }
          }
        })
        .catch((error) => console.log(error));
    },
    getOtpusks() {
      this.$store.dispatch("startLoading");

      // DAILY
      let firstDate = this.date;
      let secondDate = this.date;
      // WHOLE WEEK
      if (this.activePeriodTab === 1) {
        firstDate = new Date(this.date).GetFirstDayOfWeek();
        secondDate = new Date(this.date).GetLastDayOfWeek();
      }

      let requestUrl = `${
        process.env.VUE_APP_BASE_URI
      }/otpusk?from=${firstDate.toISOString()}&to=${secondDate.toISOString()}`;

      this.$http
        .get(requestUrl)
        .then((response) => {
          this.$store.dispatch("stopLoading");
          this.otpusks = response.data;
        })
        .catch((error) => console.log(error));
    },
    getCanApprove() {
      const url = `${process.env.VUE_APP_BASE_URI}/otpusk/can-approve`;
      this.$http
        .get(url)
        .then((response) => {
          this.canApprove = response.data.canApprove;
        })
        .catch((error) => console.log(error));
    },
    confirmOtpusk(o, conf) {
      if (
        confirm(
          `Сигурни ли сте, че искате да ${
            conf ? "одобрите" : "неодобрите"
          } отпуска?`
        )
      ) {
        const url = `${process.env.VUE_APP_BASE_URI}/otpusk/${o._id}`;

        this.$http
          .put(url, { confirmed: conf })
          .then(() => {
            this.$snotify.success(
              `Отпускът е успешно ${
                conf
                  ? "одобрен. След 2 секунди ще бъде отворен Outlook."
                  : "неодобрен."
              }`
            );
            if (conf) {
              setTimeout(() => {
                this.getOutlookUrl(o);
              }, 2000);
            }

            this.newLog(
              conf ? "confirmOtpusk" : "rejectOtpusk",
              `на ${o.worker.name} от ${this.$options.filters.formatDate(
                o.dateFrom
              )} до ${this.$options.filters.formatDate(o.dateTo)}`
            );
            this.fetchData();
          })
          .catch((err) => {
            console.log(err);
            this.$snotify.error(
              (err.response && err.response.data.failed) || "Нещо се обърка"
            );
          });
      }
    },
    getOutlookUrl(o) {
      let from = new Date(o.dateFrom);
      from.setHours(8, 30, 0, 0);
      let to = new Date(o.dateTo);
      to.setHours(17, 0, 0, 0);

      let url = `https://outlook.live.com/owa/?enddt=${encodeURIComponent(
        to.toISOString()
      )}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${encodeURIComponent(
        from.toISOString()
      )}&subject=`;

      let subject = `${this.otpuskTypes[o.type]} ${
        o.comment ? o.comment : ""
      } на ${o.worker.name}`;

      url += encodeURIComponent(subject);

      window.open(url);
    },
    removeOtpusk(otp) {
      if (confirm("Искате ли да изтриете тaзи отпуска?")) {
        let url = `${process.env.VUE_APP_BASE_URI}/otpusk/${
          otp._id
        }?by=${encodeURIComponent(this.getUser.name)}`;
        this.$http
          .delete(url)
          .then((result) => {
            if (result.data.errors) {
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
              console.log(result.data.errors);
            } else {
              this.$snotify.success(`Успешно изтрит отпуск.`);
              this.newLog(
                "deleteOtpusk",
                `на ${otp.worker.name} от ${this.$options.filters.formatDate(
                  otp.dateFrom
                )} до ${this.$options.filters.formatDate(otp.dateTo)}`
              );
              this.fetchData();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          });
      }
    },
    openCopyMoveCalendarModal(type, c) {
      this.CopyMoveCalendarModalAction = type;
      this.CopyMoveCalendarModalCalendar = c;
    },
    closeCopyMoveCalendarModal(e) {
      this.CopyMoveCalendarModalAction = "";
      this.CopyMoveCalendarModalCalendar = undefined;
      if (e.updated) {
        this.fetchData();
      }
    },
    removeCalendar(c) {
      if (confirm("Искате ли да изтриете този обект?")) {
        if (c._id) {
          let url = `${process.env.VUE_APP_BASE_URI}/calendar/${c._id}`;
          this.$http
            .delete(url)
            .then((result) => {
              if (result.data.errors) {
                this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
                console.log(result.data.errors);
              } else {
                this.$snotify.success(`Успешно изтрит обект.`);
                this.fetchData();
                if (result.data.calendar.objectId) {
                  let url = `${process.env.VUE_APP_BASE_URI}/company/object-name/${result.data.calendar.objectId}`;
                  return this.$http
                    .get(url)
                    .then((response) => {
                      if (response.data) {
                        let dateString = new Date(result.data.calendar.date);
                        dateString = `${dateString.getDate()} ${
                          this.months[dateString.getMonth()]
                        } ${dateString.getFullYear()}`;
                        this.newLog(
                          "deleteCalendar",
                          `обект ${response.data[0].objectName} - дата ${dateString}`
                        );
                      }
                    })
                    .catch((error) => console.log(error));
                }
              }
            })
            .catch((error) => {
              console.log(error);
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            });
        }
      }
    },
    // Close the workers modal
    closeAddCompaniesModal() {
      this.isAddCompaniesModalOpened = false;
    },
    closeAddWorkersModal() {
      this.selectedObject = undefined;
    },
    closeAddOtpuskModal(refresh) {
      if (refresh) {
        this.fetchData();
      }
      this.isAddOtpuskModalOpened = false;
    },
    changeMonth(e) {
      const currentDate = new Date(this.date).getDate();
      this.date = new Date(e);
      this.date.setDate(currentDate);
    },
    getHighlighted() {
      if (this.activePeriodTab === 1) {
        this.highlighted = { from: this.firstDay, to: this.lastDay };
      } else {
        const requestUrl = `${
          process.env.VUE_APP_BASE_URI
        }/calendar/highlighted?date=${this.date.toISOString()}`;

        this.$http
          .get(requestUrl)
          .then((response) => {
            this.highlightedDates = [];
            if (response.data.dates) {
              response.data.dates.map((d) => {
                this.highlightedDates.push(new Date(d));
              });
            }

            this.highlighted = {
              dates: this.highlightedDates,
            };
          })
          .catch((error) => console.log(error));
      }
    },
    scrollH(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      document.getElementById("rightPanel").scrollLeft -= delta * 40;
      e.preventDefault();
    },
  },
  mounted() {
    this.getCanApprove();
    if (this.$route.params.tab === "4" && this.$route.query.date) {
      this.date = new Date(this.$route.query.date);
    } else {
      const todayCell = document.getElementsByClassName("today")[0];
      if (todayCell) {
        todayCell.click();
      } else {
        this.date = new Date();
      }
    }

    if (!this.getUser.permissions.isAdmin || window.innerWidth < 1000) {
      this.$router.push(`/calendar/3`);
    }

    this.fetchData();
    this.getHighlighted();

    this.$on("mousewheel", this.scrollH, false);
    // Start listening for children's events
    this.$on("saveAddCompaniesModal", this.handleCompanies);
    this.$on("saveAddUsersModal", this.handleWorkers);
    // Close listening for children's events
    this.$on("closeAddCompaniesModal", this.closeAddCompaniesModal);
    this.$on("closeAddUsersModal", this.closeAddWorkersModal);
    this.$on("closeCopyMoveCalendarModal", this.closeCopyMoveCalendarModal);
    this.$on("closeAddOtpuskModal", this.closeAddOtpuskModal);
  },
  destroyed() {
    // Stop listening
    this.$off("mousewheel");
    this.$off("saveAddCompaniesModal");
    this.$off("saveAddUsersModal");
    this.$off("closeAddCompaniesModal");
    this.$off("closeAddUsersModal");
    this.$off("closeCopyMoveCalendarModal");
    this.$off("closeAddOtpuskModal");
  },
};
</script>

<style scoped>
/* IT WILL BE A GOOD IDEA TO REFACTOR THE WHOLE CSS  */
label {
  color: #373737;
  font-size: 11px;
  font-weight: 700;
}
.week {
  background-color: #f0f0f7;
  border: 0;
  text-align: center;
  width: 300px;
}
.calendar-wrapper {
  display: flex;
}
.calendar {
  background-color: #f0f0f7;
  padding: 10px 40px;
  transition: all 0.3s;
  width: 100%;
}
.calendar-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.calendar-header h2 {
  color: #373737;
  font-size: 20px;
}
.calendar-header-left {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  /* width: 300px; */
}
.calendar-header-left label {
  white-space: nowrap;
}
.calendar-content {
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  margin-top: 10px;
  min-height: calc(100vh - 166px);
  /* max-height: calc(100vh - 166px); */
  padding: 12px 15px;
}
.left-panel {
  display: flex;
  border-right: 1px solid rgba(234, 240, 244, 0.5);
  flex-direction: column;
  margin-right: 22px;
  padding-right: 22px;
  min-width: 22vw;
  width: 22vw;
}
.left-panel-header {
  align-items: center;
  display: flex;
  height: 45px;
  min-height: 45px;
  justify-content: space-between;
  padding-bottom: 10px;
}
.views {
  display: flex;
  width: 100%;
}

.view {
  background-color: #f5f5f5;
  border: 1px solid #d7dae2;
  color: #4d4f5c;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  height: 35px;
  min-width: 80px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 50%;
}
.view:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.view:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.view-active {
  background-color: #3b86ff;
  border: 1px solid #3b86ff;
  color: #ffffff;
}
.view:hover {
  background-color: #f9f9f9;
}
.view-active:hover {
  background-color: #5193fd;
}
.new-content-data-item {
  height: 100%;
  overflow: auto;
  position: relative;
  max-height: 50vh;
  width: 100%;
}
.new-content-data-item-toggle {
  background-color: #dde8ef;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 11px;
  height: 36px;
  min-height: 36px;
  margin-top: 10px;
  width: 100%;
  -webkit-transition: none;
  -moz-transition: none;
  -ms-transition: none;
  -o-transition: none;
  transition: none;
  z-index: 1;
}
.new-content-data-item-toggle:hover {
  background-color: #d8d8d8;
}
.new-content-data-item-toggle .new-content-data-item-toggle-circle {
  position: absolute;
  right: 10px;
  top: 6px;
}
.add-wrapper {
  width: 100%;
}
.add {
  align-items: center;
  background-color: #3b86ff;
  border: 0;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  font-size: 11px;
  height: 50px;
  justify-content: space-between;
  /* font-weight: 700; */
  padding: 0 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}
.add:hover {
  background-color: #5193fd;
}
.add-wrapper span.new-content-data-item-toggle-circle {
  background-color: #ffffff;
  font-size: 16px;
  color: #0078d7;
}
.add-wrapper .new-content-data-item-toggle-circle .miv2 {
  background-color: #ffffff;
  border-color: #ffffff;
}
.add-wrapper:hover .new-content-data-item-toggle-circle .miv2 {
  border-color: #3b86ff;
}
.right-panel {
  display: flex;
  flex-direction: column;
  /* overflow: auto; */
  overflow-y: auto;
  width: 100%;
}
.selected-date {
  font-size: 18px;
  padding: 7px 0;
}
.overtime {
  background-color: rgba(252, 252, 229, 0.63);
  border: 1px solid #eaf0f4;
  transform: rotate(270deg);
}
.normal {
  background-color: rgba(232, 245, 233, 0.37);
  border: 1px solid #eaf0f4;
  transform: rotate(270deg);
}
/* WORKERS */
.workers-calendar,
.objects-calendar,
.big-calendar {
  display: flex;
  height: 100%;
}
.workers-calendar-item,
.objects-calendar-item,
.big-calendar-item {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 180px;
  width: 180px;
}
.workers-calendar-item-header,
.objects-calendar-item-header,
.date-calendar-item-header {
  align-items: center;
  background-color: #f5f6fa;
  border: 1px solid #eaf0f4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 6px;
  max-height: 75px;
  min-height: 75px;
  padding: 10px 0;
  width: 100%;
}
.workers-calendar-item-header {
  max-height: 35px;
  min-height: 35px;
}
.workers-calendar-item:first-child .workers-calendar-item-header,
.objects-calendar-item:first-child .objects-calendar-item-header,
.big-calendar-item:first-child .date-calendar-item-header {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.workers-calendar-item:last-child .workers-calendar-item-header,
.objects-calendar-item:last-child .objects-calendar-item-header,
.big-calendar-item:last-child .date-calendar-item-header {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.workers-calendar-item-header p,
.objects-calendar-item-header p,
.date-calendar-item-header p {
  font-size: 9px;
  font-weight: 400;
  opacity: 0.5;
  text-align: center;
}
.workers-calendar-item-header p:nth-child(3),
.objects-calendar-item-header p:nth-child(3),
.date-calendar-item-header p:nth-child(3) {
  font-size: 12px;
  font-weight: 700;
}
.workers-calendar-item-content,
.objects-calendar-item-content,
.big-calendar-item-content {
  align-items: center;
  border: 1px solid #eaf0f4;
  border-radius: 4px;
  flex-direction: column;
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  padding: 5px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  position: relative;
  width: 176px;
}
.objects-calendar-item-content-highlight {
  background-color: #919191;
}
.workers-calendar-item-content:hover,
.objects-calendar-item-content:hover,
.big-calendar-item-content:hover {
  background-color: #edf1f5;
}
.new-content-data-item-content {
  display: flex;
  flex-direction: column;
}
.new-content-data-item-content-no-results {
  height: 100%;
  justify-content: center;
  align-items: center;
}
.new-content-data-item-content p {
  color: #737373;
  font-size: 11px;
  padding: 5px;
}
.add-items-wrapper {
  width: 100%;
}
.workers-calendar-item-content-add,
.objects-calendar-item-content-add,
.big-calendar-item-content-add {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  padding: 4px;
  width: 100%;
}
.objects-calendar-item-content-add-hidden {
  opacity: 0;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.objects-calendar-item-content-add-item {
  align-items: center;
  border-radius: 4px;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  padding: 15px 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}
.objects-calendar-item-content-add-item-big {
  height: 100%;
  width: 100%;
}
.objects-calendar-item-content-add-item:hover {
  background-color: #fff;
}
.objects-calendar-item-content-add-item-big:hover {
  background: rgba(237, 241, 245, 0.8);
}
.workers-calendar-item-content-add-item .miv,
.workers-calendar-item-content-add-item .miv2,
.objects-calendar-item-content-add-item .miv,
.objects-calendar-item-content-add-item .miv2,
.big-calendar-item-content-add-item .miv,
.big-calendar-item-content-add-item .miv2 {
  align-items: center;
  background-color: #3b86ff;
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-size: 16px;
  flex-direction: column;
  height: 34px;
  justify-content: center;
  margin-bottom: 6px;
  position: relative;
  width: 34px;
}
.add-item-copy .miv2 {
  background-color: #008a23;
}
.add-item-move .miv2 {
  background-color: #68009f;
}
.add-item-delete .miv {
  background-color: #d44b00;
}
.add-item-confirm .miv2 {
  background-color: #02d125;
  font-size: 12px;
}
.add-item-reject .miv {
  background-color: #d11f02;
  font-size: 12px;
}
.workers-calendar-item-content-add-item .miv::after,
.workers-calendar-item-content-add-item .miv2::after,
.objects-calendar-item-content-add-item .miv::after,
.objects-calendar-item-content-add-item .miv2::after,
.big-calendar-item-content-add-item .miv::after,
.big-calendar-item-content-add-item .miv2::after {
  content: "";
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 50%;
  height: 30px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 30px;
}
.workers-calendar-item-content:hover .workers-calendar-item-content-add-hidden,
.objects-calendar-item-content:hover .objects-calendar-item-content-add-hidden,
.big-calendar-item-content:hover .big-calendar-item-content-add-hidden {
  background-color: rgba(237, 241, 245, 0.8);
  opacity: 1;
}
.objects-calendar-item-content .otpusks-hover-container {
  /* justify-content: flex-end; */
  z-index: 1;
}
.objects-calendar-item-content
  .otpusks-hover-container
  .otpusks-container-top
  p {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  padding: 15px;
}
.objects-calendar-item-content
  .otpusks-hover-container
  .otpusks-container-bottom {
  width: 100%;
}
.objects-calendar-item-content .otpusks-hover-container .add-items-wrapper {
  display: flex;
}
.objects-calendar-item-content:hover .otpusks-hover-container {
  background-color: rgba(0, 0, 0, 0.8);
}
.workers-calendar-item-content-add-item:hover .miv::after,
.workers-calendar-item-content-add-item:hover .miv2::after,
.objects-calendar-item-content-add-item:hover .miv::after,
.objects-calendar-item-content-add-item:hover .miv2::after,
.big-calendar-item-content-add-item:hover .miv::after,
.big-calendar-item-content-add-item:hover .miv2::after {
  border: 1px solid #fff;
}
.workers-calendar-item-content-add p,
.objects-calendar-item-content-add p,
.big-calendar-item-content-add p {
  font-size: 10px;
  text-align: center;
}
.otpusks-hover-container .objects-calendar-item-content-add-item p {
  color: #fff;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.otpusks-hover-container .objects-calendar-item-content-add-item:hover p {
  color: #000;
}
.no-results-calendar {
  width: 100%;
}
.no-results-calendar .workers-calendar-item {
  width: 100%;
}
.no-results-calendar .workers-calendar-item-content {
  width: 100%;
  cursor: default;
}
.no-results-calendar .workers-calendar-item-content:hover {
  background-color: transparent;
}
.companies-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  justify-content: center;
  width: 100%;
}
.companies-tag,
.personal-tag {
  align-items: center;
  background-color: #fff59d;
  display: flex;
  border-radius: 4px;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 5px;
  margin-bottom: 5px;
  min-height: 180px;
  width: 100%;
}
.personal-tag {
  background-color: #bbdefb;
}
.companies-tag:last-child,
.personal-tag:last-child {
  margin-bottom: 0;
}
.companies-tag p,
.personal-tag p {
  font-size: 10px;
  line-height: 12px;
  opacity: 0.5;
  margin: 3px 0;
  text-align: center;
}
.companies-tag p:nth-child(3),
.personal-tag p:nth-child(3) {
  font-size: 16px;
  line-height: 20px;
  margin: 5px 0 0;
  text-align: center;
  opacity: 1;
}
.workers-container,
.otpusk-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  justify-content: center;
  width: 100%;
}
.workers-container__loading {
  text-align: center;
  width: 100%;
}
.otpusk-container {
  background-color: rgb(242, 242, 242);
  justify-content: space-between;
}
.otpusk-container-true {
  background-color: rgb(226, 239, 217);
}
.otpusk-container-false {
  background-color: rgb(251, 213, 213);
}
.otpusk-container-bottom,
.otpusk-container-top {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 50%;
  justify-content: space-around;
  padding: 5px;
  width: 100%;
}
.otpusk-container-bottom {
  justify-content: center;
}
.otpusk-container-bottom p,
.otpusk-container-top p {
  text-align: center;
}
.otpusk-period-div {
  display: flex;
  flex-direction: column;
}
.otpusk-container-bottom .otpusk-period-div {
  margin-bottom: 20px;
}
.otpusk-period-div p {
  font-size: 12px;
}
/* .otpusk-period-div p:first-child {
  margin-bottom: 5px;
} */
.otpusk-status {
  align-items: center;
  background-color: #ffdc50;
  border: none;
  border: 1px solid #bf9d11;
  border-radius: 4px;
  color: #9e7e00;
  display: flex;
  font-size: 12px;
  /* min-height: 40px; */
  font-weight: 700;
  justify-content: space-between;
  margin-bottom: 4px;
  color: #9e7e00;
  padding: 0 8px;
}
.otpusk-status .miv2 {
  font-size: 14px;
}
.otpusk-status-confirmed {
  background-color: #70ad47;
  border: 1px solid #386818;
  color: #fff;
}
.otpusk-status-rejected {
  background-color: #c53c11;
  border: 1px solid #811f00;
  color: #fff;
}
.workers-tag {
  align-items: center;
  background-color: #7b9295;
  color: #fff;
  border-radius: 4px;
  font-size: 10px;
  height: 100%;
  display: flex;
  margin: 2px 0;
  padding: 5px 10px;
  justify-content: center;
  width: 100%;
}
.workers-tag--not-reported {
  background-color: #d98a8a;
}
.workers-tag--reported {
  background-color: #a9d2a7;
}
.workers-tag--reported-elsewhere {
  background-color: #ecc98c;
}
.workers-tag--reported-nonplanned {
  background-color: #9fd3e3;
}
.date-calendar-item-header .date-calendar-objects-count {
  align-items: center;
  background-color: #e1e5f3;
  border-radius: 15px;
  color: #000;
  opacity: 1;
  font-weight: 400;
  display: flex;
  justify-content: center;
  margin-top: 5px;
  padding: 7px;
  width: 90%;
}
.date-calendar-item-header .date-calendar-objects-count .miv2 {
  font-size: 14px;
  font-weight: 400;
  margin-right: 5px;
}
.big-calendar-count-toggle {
  align-items: center;
  background-color: #104d80;
  border-radius: 30px;
  color: #fff;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  position: relative;
  padding: 5px 10px;
}
.big-calendar-count-toggle span {
  font-size: 14px;
}
.big-calendar-count-toggle .miv2 {
  font-size: 20px;
  margin-right: 5px;
}
.company {
  align-items: start;
  padding: 4px;
}
.btn {
  margin: 0;
}
.btn-plan {
  background: #083f75;
  border-radius: 4px;
  border: 0;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  margin: 10px 0;
  text-align: center;
  transition: all 0.3s;
}
.btn-plan:hover {
  opacity: 0.8;
}
.legend {
  width: 100%;
}
/* * */
/* PERSONAL */
/* * */
.personal-calendar {
  display: block;
}
.personal-calendar .big-calendar-item {
  width: 100%;
}
.personal-calendar .big-calendar-item-content {
  width: 100%;
}
.personal-calendar .personal-tag {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  min-height: 150px;
  padding: 20px 10px;
}
.personal-calendar .personal-tag .left {
  border-right: 1px solid #104d80;
  margin-right: 50px;
  padding: 0 8px;
  position: relative;
  width: 50%;
}
.personal-calendar .personal-tag .left p {
  text-align: right;
}
.personal-calendar .personal-tag .right {
  border-left: 1px solid #104d80;
  margin-left: 50px;
  padding: 0 10px;
  position: relative;
  width: 50%;
}
.personal-calendar .personal-tag .right p {
  color: #104d80;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  opacity: 1;
  text-align: left;
}
.personal-calendar .personal-tag .left::before,
.personal-calendar .personal-tag .right::before {
  color: #104d80;
  content: "P";
  font-family: "miv2";
  font-size: 20px;
  position: absolute;
  top: 0;
}
.personal-calendar .personal-tag ::before {
  right: -30px;
}
.personal-calendar .personal-tag .right::before {
  content: "Q";
  left: -30px;
}
.otpusk-status-wrapper {
  padding-top: 15px;
}
.opacity-zero {
  opacity: 0;
}
.mobile-inline {
  display: none;
}
.mobile-datepicker {
  display: none;
}
@media screen and (max-width: 1440px) {
  .left-panel {
    min-width: 25vw;
    width: 25vw;
  }
}
@media screen and (max-width: 1366px) {
  .left-panel {
    min-width: 28vw;
    width: 28vw;
  }
}
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile-inline {
    display: inline;
  }
  .calendar {
    padding: 10px 15px;
  }
  .calendar-content {
    flex-direction: column;
  }
  .calendar-header {
    position: relative;
  }
  .left-panel {
    border: none;
    margin: 0;
    padding: 0;
    width: 100%;
  }
  .left-panel-header {
    padding-bottom: 15px;
  }
  .mobile-datepicker {
    display: inline-flex;
    position: relative;
    width: 100%;
  }
  .mobile-datepicker-toggle {
    align-items: center;
    background-color: #f5f5f5;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    cursor: pointer;
    display: inline-flex;
    justify-content: space-between;
    height: 35px;
    padding: 0 10px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 100%;
  }
  .mobile-datepicker-toggle:hover {
    background-color: #f9f9f9;
  }
  .mobile-datepicker-toggle span {
    font-size: 12px;
  }
  .mobile-datepicker-toggle .miv {
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }
  .mobile-datepicker-toggle .rotate-arrow {
    transform: scale(-1);
  }
  .mobile-datepicker-wrapper {
    position: absolute;
    /* height: 100%; */
    /* left: 50%; */
    top: calc(100% + 10px);
    /* width: 100%; */
    z-index: 1;
  }
  .calendar-header-left {
    margin-left: 10px;
  }
  .no-results-calendar-p {
    font-size: 12px;
    text-align: center;
  }
  .otpusk-status {
    padding: 10px 8px;
  }
  .objects-calendar-item-content-add-hidden {
    display: none;
  }
  .otpusk-container-bottom,
  .otpusk-container-top {
    height: initial;
    padding: 15px 5px 5px;
  }
}
@media screen and (max-width: 600px) {
  .mobile-datepicker {
    position: initial;
  }
  .view {
    min-width: 40px;
  }
  .personal-calendar .personal-tag {
    justify-content: center;
    flex-direction: column;
  }
  .personal-calendar .personal-tag .left,
  .personal-calendar .personal-tag .right {
    border-left: 1px solid #104d89;
    border-right: none;
    margin: 0 0 0 35px;
    width: calc(100% - 35px);
  }
  .personal-calendar .personal-tag .left {
    margin-bottom: 10px;
  }
  .personal-calendar .personal-tag .left p,
  .personal-calendar .personal-tag .right p {
    text-align: left;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    right: initial;
    left: -30px;
  }
  .companies-tag p,
  .personal-tag p {
    font-size: 9px;
    margin: 0;
  }
  .companies-tag p:nth-child(3),
  .personal-tag p:nth-child(3) {
    font-size: 13px;
    margin: 0;
  }
  .personal-calendar .personal-tag .right p {
    font-size: 11px;
    line-height: 14px;
  }
  .no-results-calendar-p {
    font-size: 10px;
  }
}
@media screen and (max-width: 440px) {
  .mobile-datepicker-toggle span {
    font-size: 10px;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    font-size: 15px;
  }
  .personal-calendar .personal-tag .left,
  .personal-calendar .personal-tag .right {
    width: calc(100% - 25px);
    margin-left: 25px;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    left: -25px;
  }
}
</style>
